import { useForm } from 'react-hook-form';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
import { FocusHighlightCard } from './FocusHighlightCard';
import type { SectionProps } from './types';

type CommunicationsFormValues = {
  medicalCommunication: string;
  evacuationCommunication: string;
  otherCommunication: string;
};

export function CardEmergencyCommunications({
  row,
  upsertWala,
  canEditCards,
}: SectionProps) {
  const defaultValues: CommunicationsFormValues = {
    medicalCommunication: row.original.medicalCommunication ?? '',
    evacuationCommunication: row.original.evacuationCommunication ?? '',
    otherCommunication: row.original.otherCommunication ?? '',
  };
  // `values` (not `defaultValues`) so the inputs follow the refetched card
  // when the 204 changes outside this form (e.g. an AI skills update).
  const { register, handleSubmit, reset } = useForm<CommunicationsFormValues>({
    values: defaultValues,
  });

  const onSubmit = handleSubmit((values) => {
    upsertWala(row, values);
    (document.activeElement as HTMLElement | null)?.blur();
  });

  return (
    <FocusHighlightCard size="sm">
      <CardHeader>
        <CardTitle>Emergency Communications</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="tw:grid tw:gap-4">
          <div className="tw:grid tw:grid-cols-3 tw:gap-2">
            <Field>
              <FieldLabel htmlFor="communications-medical">
                Medication
              </FieldLabel>
              <Input
                id="communications-medical"
                {...register('medicalCommunication')}
              />
            </Field>
            <Field>
              <FieldLabel htmlFor="communications-evacuation">
                Evacuation
              </FieldLabel>
              <Input
                id="communications-evacuation"
                {...register('evacuationCommunication')}
              />
            </Field>
            <Field>
              <FieldLabel htmlFor="communications-other">Other</FieldLabel>
              <Input
                id="communications-other"
                {...register('otherCommunication')}
              />
            </Field>
          </div>
          <div className="tw:invisible tw:flex tw:gap-2 tw:group-focus-within/card:visible">
            <Button type="submit" size="sm" disabled={!canEditCards}>
              Save
            </Button>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={(event) => {
                reset(defaultValues);
                event.currentTarget.blur();
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </CardContent>
    </FocusHighlightCard>
  );
}
